
import React, { Component } from 'react';
import { signInWithGoogle } from '../helpers/auth';
import { signInWithFacebook } from '../helpers/auth';
import { signInAsGuest } from '../helpers/auth';

export default class Login extends Component {
	constructor() {
		super();
        this.state = {
            error: null,
            email: '',
            password: '',
            userName: '',
            isGuest: false,
        };
        this.googleSignIn = this.googleSignIn.bind(this);
        this.facebookSignIn = this.facebookSignIn.bind(this);
        this.guestSignIn = this.guestSignIn.bind(this);
        this.startAsGuest = this.startAsGuest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
	}

    async googleSignIn() {
        try {
            await signInWithGoogle();
        } catch (error) {
            console.log(error)
            this.setState({ error: error.message });
        }
    }

    async facebookSignIn() {
        try {
            await signInWithFacebook();
        } catch (error) {
            console.log(error)
            this.setState({ error: error.message });
        }
    }

    async guestSignIn() {
        try {
            await signInAsGuest();
        } catch (error) {
            console.log(error)
            this.setState({ error: error.message });
        }
    }

    startAsGuest() {
        this.setState({ isGuest: true })
    }

    handleChange(event) {
        this.setState({
            userName: event.target.value
        });
    }

    async handleSubmit(event) {
        event.preventDefault();
        signInAsGuest(this.state.userName)
    }

    render() {
        if (this.state.isGuest === false) {
            return (
                <div>
                    <div>Please sign in:</div>
                    <div className='py-2'>
                        <button onClick={this.googleSignIn} type='button' >
                            Google
                        </button>
                    </div>
                    <div className='py-2'>
                        <button onClick={this.facebookSignIn} type='button' >
                            Facebook
                        </button>
                    </div>
                    <div className='py-4'>
                        <button onClick={this.startAsGuest} type='button' >
                            Sign in as Guest
                        </button>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <form onSubmit={this.handleSubmit} className='mx-3 my-3'>
                        <div><strong>username</strong></div>
                        <input className='px-5 mt-4' name='content' onChange={this.handleChange} value={this.state.userName} />
                        {this.state.error ? <p className='text-danger'>{this.state.writeError}</p> : null}
                        <div>
                            <button type='submit' className='btn-submit px-5 mt-4'>SignIn</button>
                        </div>
                    </form>
                </div>
            )
        }
    }
}
